 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import AA01ROWMANSERIES_COVER from '@/components/1A01Rowman.Series_cover'
 import AA01ROWMANSERIES_FRONTMATTER from '@/components/1A01Rowman.Series_frontmatter'
 import AB02FOREWORD from '@/components/3B02foreword'
 import AB03TIMELINE from '@/components/4B03timeline'
 import AB04ACKNOWLEDGMENTS from '@/components/5B04acknowledgments'
 import AB05INTRODUCTION from '@/components/6B05introduction'
 import AC01CHAP01 from '@/components/7C01chap01'
 import AC02CHAP02 from '@/components/8C02chap02'
 import AC03CHAP03 from '@/components/9C03chap03'
 import A0C04CHAP04 from '@/components/10C04chap04'
 import A1C05CHAP05 from '@/components/11C05chap05'
 import A2C06CHAP06 from '@/components/12C06chap06'
 import A3C07CHAP07 from '@/components/13C07chap07'
 import A4D01FURTHERREADING from '@/components/14D01FurtherReading'
 import A5D02FURTHERLISTENING from '@/components/15D02FurtherListening'
 import A6I01INDEX from '@/components/16I01index'
 import A7J01AUTHOR from '@/components/17J01author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/1A01Rowman.Series_cover",
 			"name" : "1A01Rowman.Series_cover",
 			"component" : AA01ROWMANSERIES_COVER
 		},
 		{
 			"path" : "/1A01Rowman.Series_frontmatter",
 			"name" : "1A01Rowman.Series_frontmatter",
 			"component" : AA01ROWMANSERIES_FRONTMATTER
 		},
 		{
 			"path" : "/3B02foreword",
 			"name" : "3B02foreword",
 			"component" : AB02FOREWORD
 		},
 		{
 			"path" : "/4B03timeline",
 			"name" : "4B03timeline",
 			"component" : AB03TIMELINE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js